import React, { useState, useEffect, useRef } from 'react';

import { useStaticQuery, graphql } from 'gatsby';

import {
  FormattedMessage,
  useIntl,
} from '../../../plugins/publicis-gatsby-plugin-i18n';
import { CloseIconThin, RoundedHalfCircle } from '../../Atoms/Icons/Icons';
import useMedias from '../../hooks/useMedias';
import Checkbox from '../../Molecules/Checkbox/Checkbox';
import Link from '../../Molecules/Link/Link';
import TitleSection from '../../Molecules/TitleSection/TitleSection';
import { removeHtmlTag } from '../../Utils/Utils';

import './PopinDiscoverStore.scss';


let classNames = require('classnames');

const PopinDiscoverStore = () => {
  const intl = useIntl();
  const { processUrl } = useMedias();

  const popinRef = useRef();
  const data = useStaticQuery(graphql`
    query StoreQuery {
      siteInternet: allNodeSiteInternet(
        sort: { order: ASC, fields: field_ordre }
      ) {
        edges {
          node {
            field_link {
              url
              title
            }
            body {
              processed
            }
            relationships {
              field_category {
                name
                drupal_internal__tid
              }
              field_image {
                drupal_internal__mid
                relationships {
                  field_media_image {
                    uri {
                      url
                    }
                   image_style_uri {
                      gatsby_wide
                    }
                  }
                }
              }
            }
            langcode
          }
        }
      }
    }
  `);

  const [filterValue, setFilterValue] = useState('filter_all');

  // Filtre des images sur le FR car images disponibles uniquement en FR.
  const imagesUrl = data.siteInternet?.edges
    ?.filter(({ node }) => node.langcode === 'fr')
    .map(({ node }) => ({
      id: node.relationships.field_image.drupal_internal__mid,
      image_full:
        node.relationships.field_image.relationships.field_media_image?.image_style_uri?.gatsby_wide,
      image_croped:
        node.relationships.field_image.relationships.field_media_image?.image_style_uri?.gatsby_wide,
    }));

  const sitesExpertise = data.siteInternet?.edges
    ?.filter(
      ({ node }) =>
        node.langcode === intl.locale &&
        node.relationships?.field_category?.drupal_internal__tid == 16
    )
    .map(({ node }) => ({
      image: imagesUrl.find(
        (img) =>
          img.id === node.relationships?.field_image?.drupal_internal__mid
      )?.image_full,
      link: node.field_link?.url,
      link_text: node.field_link?.title,
      text: node.body?.processed,
    }));

  const sitesPays = data.siteInternet?.edges
    ?.filter(
      ({ node }) =>
        node.langcode === intl.locale &&
        node.relationships?.field_category?.drupal_internal__tid == 15
    )
    .map(({ node }) => ({
      image: imagesUrl.find(
        (img) =>
          img.id === node.relationships?.field_image?.drupal_internal__mid
      )?.image_croped,
      link: node.field_link?.url,
      link_text: node?.field_link?.title,
      text: node.body?.processed,
    }));

  const filterList = (id) => {
    setFilterValue(id);
  };

  const closePopin = (e) => {
    e.preventDefault();
    document.body.classList.remove('show_popin_stores');
    document.body.classList.remove('popin_open');
    document
      .querySelector('.sticky-allsites')
      .setAttribute('aria-expanded', 'false');
    setFilterValue('filter_all');
  };

  useEffect(() => {
    if (popinRef.current) {
      popinRef.current.addEventListener('keydown', onKeyPressed);
      return () => {
        popinRef.current
          ? popinRef.current.removeEventListener('keydown', onKeyPressed)
          : null;
      };
    }
  }, []);

  const onKeyPressed = (e) => {
    if (e.keyCode === 9 && e.target.closest('.popin_content')) {
      const currentItem = e.target.closest('.popin_content').dataset.count;
      const lastItemIndex =
        popinRef.current.querySelectorAll('.popin_content')[
          popinRef.current.querySelectorAll('.popin_content').length - 1
        ].dataset.count;
      if (currentItem === lastItemIndex) {
        popinRef.current.querySelector('.close_search').focus();
        e.preventDefault();
      }
    }
  };

  return (
    <div
      className="popin_discover_store_component"
      role="dialog"
      aria-modal="true"
      ref={popinRef}
    >
      <div className="top_bar">
        <a
          href="#"
          aria-label={intl.formatMessage({ id: 'ariaLabel.close_modal' })}
          className="close_search"
          id="close_popin_discover_sites"
          onClick={closePopin}
        >
          <CloseIconThin />
          <FormattedMessage id="common.close">
            {(x) => <span>{x}</span>}
          </FormattedMessage>
        </a>
        <form
          className="checkbox_container"
          aria-label={intl.formatMessage({ id: 'ariaLabel.select_one_option' })}
          role="radiogroup"
        >
          <Checkbox
            change={filterList}
            field={{
              id: 'filter_all',
              filed_type: 'checkbox',
              type: 'radio',
              name: 'filter_radio',
              label: intl.formatMessage(
                { id: 'store.site.all' },
                { nb: `(${sitesExpertise.length + sitesPays.length})` }
              ), // Tous les sites internet (35)
              value: filterValue === 'filter_all' ? true : false,
            }}
          />
          <Checkbox
            change={filterList}
            field={{
              id: 'filter_country',
              filed_type: 'checkbox',
              type: 'radio',
              name: 'filter_radio',
              label: intl.formatMessage(
                { id: 'store.site.country' },
                { nb: `(${sitesPays.length})` }
              ), // Sites internet Des pays (18)
              value: filterValue === 'filter_country' ? true : false,
            }}
          />
          <Checkbox
            change={filterList}
            field={{
              id: 'filter_expertise',
              filed_type: 'checkbox',
              type: 'radio',
              name: 'filter_radio',
              label: intl.formatMessage(
                { id: 'store.site.expertise' },
                { nb: `(${sitesExpertise.length})` }
              ), // Sites internet d’expertises (8)
              value: filterValue === 'filter_expertise' ? true : false,
            }}
          />
        </form>
      </div>
      <div className="links_container">
        <div className="wrapper_page_xs">
          {(filterValue === 'filter_all' ||
            filterValue === 'filter_expertise') && (
              <div className="result_container">
                <div className="search_results">
                  <div className="category">
                    <TitleSection
                      title={intl.formatMessage(
                        { id: 'store.site.expertise' },
                        { nb: '' }
                      )}
                      type="arrow"
                    />
                    <div className="popin_main">
                      {sitesExpertise.map((site, i) => (
                        <div
                          key={i}
                          className="popin_content"
                          data-count={'item_' + i}
                        >
                          <div className="logo">
                            <RoundedHalfCircle />
                            <div className="rounded_logo">
                              <img
                                src={processUrl(site.image)}
                                alt={'Logo ' + site.link_text}
                                width="70"
                                height="90"
                                loading="lazy"
                                style={{ objectFit: 'cover' }}
                              />
                            </div>
                          </div>
                          <div className="popin_link">
                            <Link
                              href={site.link}
                              target="_blank"
                              ariaLabel={
                                intl.formatMessage({ id: 'common.goto_on' }) +
                                ' ' +
                                site.link_text +
                                ' - ' +
                                intl.formatMessage({ id: 'common.new_tab' })
                              }
                              tracking="expertise_site"

                            >
                              {site.link_text}
                            </Link>
                            <div
                              dangerouslySetInnerHTML={{ __html: site.text }}
                            ></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          {(filterValue === 'filter_all' ||
            filterValue === 'filter_country') && (
              <div className="result_container">
                <div className="search_results">
                  <div className="category">
                    <TitleSection
                      title={intl.formatMessage(
                        { id: 'store.site.country' },
                        { nb: '' }
                      )}
                      type="arrow"
                    />
                    <div className="popin_main">
                      {sitesPays.map((site, i) => (
                        <div
                          key={i}
                          className="popin_content"
                          data-count={'item_' + (sitesExpertise.length + i)}
                        >
                          <div className={classNames('logo', 'country')}>
                            <RoundedHalfCircle />
                            <div className="rounded_logo">
                              <img
                                src={processUrl(site.image)}
                                alt={removeHtmlTag(site.text)}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          </div>
                          <div className="popin_link">
                            <Link
                              href={site.link}
                              target="_blank"
                              ariaLabel={
                                intl.formatMessage({ id: 'common.goto_on' }) +
                                ' ' +
                                site.link_text +
                                ' - ' +
                                intl.formatMessage({ id: 'common.new_tab' })
                              }
                              tracking="pays_site"
                            >
                              {site.link_text}
                            </Link>
                            <div
                              dangerouslySetInnerHTML={{ __html: site.text }}
                            ></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default PopinDiscoverStore;
